import { render, staticRenderFns } from "./RevenueDetails.vue?vue&type=template&id=0619a4aa&scoped=true"
import script from "./RevenueDetails.vue?vue&type=script&lang=js"
export * from "./RevenueDetails.vue?vue&type=script&lang=js"
import style0 from "./RevenueDetails.vue?vue&type=style&index=0&id=0619a4aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0619a4aa",
  null
  
)

export default component.exports